import script from "./workload-view-performance-bar-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-performance-bar-chart.vue?vue&type=script&setup=true&lang=ts"

import "./workload-view-performance-bar-chart.vue?vue&type=style&index=0&id=73c8fa1a&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73c8fa1a"]])

export default __exports__